import * as model from "../../models";
import { VenueActions } from "./venue.actions"

import { AppState } from '../../reducers';
import { Observable } from 'rxjs'
import { PaginationConfig } from "../../services"

export interface VenueState {
	currentVenue: model.Venue;
	venues: model.Venue[],
	paginationConfig: {
		itemsPerPage: number;
		totalItems: number;
		currentPage: number;
	}
};

const initialState: VenueState  = {
	currentVenue: null,
	venues: [],
	paginationConfig: {
		itemsPerPage: 5,
		totalItems: 0,
		currentPage: 0
	}
}

export const venueReducer = (state: VenueState = initialState, action): VenueState => {
	switch (action.type) {
		case VenueActions.VENUE_LOADED:
			return Object.assign({}, state, { currentVenue: action.payload })
		case VenueActions.SEARCH_VENUES_SUCCESS:
			return Object.assign({}, state, { venues: action.payload })
		case VenueActions.SET_PAGINATION_CONFIG:
			return Object.assign({}, state, { paginationConfig: action.payload })

		default: return state

	}
}



// WEBPACK FOOTER //
// ./src/app/components/venue-components/venue.reducer.ts